import React from 'react';
import { Icon, Theme } from 'fitbeat.react-native-components';

const isMobile = window.innerWidth <= 550;

export function FullWidthBackLayout(props) {
  return (
    <div>
      <div className='menu-container'>
        <div className='title-bar' style={isMobile && { color: Theme.GREY_DARK_MEDIUM }}>
          <div
            className='align-middle back-arrow-container'
            onClick={() => props.navigation.navigate(props.screenSettings.backRoute)}
          >
            <Icon
              onPress={props.back}
              size={30}
              color={Theme.GREY_DARK_MEDIUM}
              name='ios-arrow-back'
            />
          </div>
          <div>
            <span className='title'>{props.screenSettings.title || ''}</span>
          </div>
          <div className='back-arrow-container' />
        </div>
      </div>
      <div className='grid-x content-top-padding'>
        <div className='cell medium-12 large-12'>
          {props.children}
        </div>
      </div>
    </div>
  );
}

export const WrapWithBackLayout = (screenSettings) => (Component) => function (props) {
  return (
    <FullWidthBackLayout
      screenSettings={screenSettings}
      {...props}
    >
      <Component {...props} />
    </FullWidthBackLayout>
  );
};
